import api from '../api/index'

const state = {
  route: [],
  routeProf: [],
  routeZon: [],
}

const mutations = {
  setRoute: function (state, payload) {
    state.route = payload
  },
  setRouteProfile: function (state, payload) {
    state.routeProf = payload
  }
}

const actions = {
  loadRaceRoute: function (context, rid) {
    api.getRaceRoute(rid, function (data) {
      context.commit('setRoute', data)
    })
  },
  loadRaceRouteProfile: function (context, rid) {
    api.getRaceRouteProfile(rid, function (data) {
      context.commit('setRouteProfile', data)
    })
  }
}

const getters = {
  route: state => {
    return state.route
  },
  routeDistance: state => {
    if(state.route.length > 0) {
      return state.route[state.route.length - 1].distance
    } else {
      return 0
    }
  },
  routeProfile: state => {
    if(state.route.length > 0) {
      return state.routeProf
    } else {
      return []
    }
  },
  routeZones: state => {
    if(state.route.length > 0) {
      return console.log(state.route.map(function(point, index) {
        if(typeof state.route[index -1] !== 'undefined') {
          if(state.route[index].colour !== state.route[index -1].colour){
            return {
              value: state.route[index - 1].distance,
              color: '#' + state.route[index - 1].colour
            }
          }
        }
      }).filter(function (item) { return item; }));
    } else {
      return []
    }
  },
  routePolyline: state => {
    return state.route.map(function(point) {
      return {
        lat: parseFloat(point.latitude),
        lng: parseFloat(point.longitude)}
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/route.js